import { render, staticRenderFns } from "./TabelaSelecionarTerritorioMonitoramento.vue?vue&type=template&id=75fa5f70&lang=pug"
import script from "./TabelaSelecionarTerritorioMonitoramento.vue?vue&type=script&lang=js"
export * from "./TabelaSelecionarTerritorioMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./TabelaSelecionarTerritorioMonitoramento.vue?vue&type=style&index=0&id=75fa5f70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports